
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import LiveShowItems from "./liveshows/liveshowItems.js";
import LiveHeader from "./header/header";
import React from "react";
import {Route, BrowserRouter as Router, Switch} from "react-router-dom";
import VideoPlayer from "./liveshows/videoPlayer";
import {getServerEndPoint} from "./liveshows/webEndPoint";
import LiveGenreShowItems from "./genre/genreChannel";
import LoginLayout from "./login/loginLayout";
import RegisterLayout from "./login/registerLayout";
import UserValidToken from "./login/UserValidToken";
import PasswordLayout from "./login/passwordLayout";
import MessageLayout from "./message/messageLayout";
import LoginBarLayout from "./login/loginBarcodeLayout";
import ConnectionBlockedPage from "./liveshows/check/checkBlockagePage";
import DownloadPage from "./login/DownloadPage";
import {SystemInfos} from "./liveshows/system/systemInfos";

function App() {
    global.serverEndpoint = getServerEndPoint()
    document.title = "km-bizz video streamer";

  return (
    <div className="App">
        <Router>
            <Switch>
                <Route exact path ="/">
                 <LoginLayout></LoginLayout>
                </Route>
                <Route exact path ="/sign-up">
                    <RegisterLayout></RegisterLayout>
                </Route>
                <Route exact path ="/password-forgotten">
                    <PasswordLayout></PasswordLayout>
                </Route>
                <Route exact path ="/redirect">
                    <UserValidToken></UserValidToken>
                </Route>
                <Route exact path ="/live">
                    <LiveHeader></LiveHeader>
                    <LiveShowItems></LiveShowItems>
                </Route>
                <Route path ="/liveVideo/:channel">
                    <VideoPlayer></VideoPlayer>
                </Route>
                <Route path ="/genre/:id">
                    <LiveHeader></LiveHeader>
                    <LiveGenreShowItems></LiveGenreShowItems>
                </Route>
                <Route exact path ="/sign-in-qrcode/:barcode">
                    <LoginBarLayout></LoginBarLayout>
                </Route>
                <Route  path ="/barcode-message">
                    <MessageLayout
                        title={"Success Login"}
                        type={"success"}
                        message={"Successfully Login, Please go to the End Device"}
                    ></MessageLayout>
                </Route>
                <Route  path ="/excessive-login-message">
                  <ConnectionBlockedPage></ConnectionBlockedPage>
                </Route>

                <Route path ="/system-infos">
                    <LiveHeader></LiveHeader>
                    <SystemInfos></SystemInfos>
                </Route>

                <Route path ="/download">
                    <DownloadPage></DownloadPage>
                </Route>
            </Switch>
        </Router>
    </div>
  );
}

export default App;
